<template>

  <!-- Quiz Subjects Slider Block -->
  <items-loader
    no-autoload
    module="vlQuizSubjects"
    class="quiz-subjects-slider-block">

    <template
      slot-scope="{items}">

      <page-block
        bg-image-contain
        v-if="items.length"
        :bg-file="value.file"
        :bg-color="value.bgColor"
        :text-color="value.textColor"
        :text-align="value.textAlign"
        :width-class="value.widthClass"
        :overlay-class="value.paddingClass">

        <page-block-header
          no-element
          class="sbs-mb"
          :value="value">

          <span
            class="text-grey text-subtitle1">
            перейти в раздел
          </span>

          <q-btn
            rounded
            to="/quiz"
            unelevated
            color="grey-4"
            class="q-ml-sm"
            text-color="primary">

            <svg
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="currentColor">

              <use
                xlink:href="/images/icons/icon-symbols.svg?v1#arrow-right"/>

            </svg>

          </q-btn>

        </page-block-header>

        <quiz-subjects-slider-content
          :value="value"
          :items="items"/>

      </page-block>

    </template>

  </items-loader>

</template>

<script>

  import {mapActions, mapMutations} from 'vuex';
  import PageBlock from '@src/components/page/page-block';
  import PageBlockHeader from '@src/components/page/page-block-header';
  import QuizSubjectsSliderContent from '@src/components/content/quiz-subjects-slider-content';

  export default {
    name: 'quiz-subjects-slider-block',
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      PageBlockHeader,
      QuizSubjectsSliderContent,
    },
    methods: {
      ...mapActions('vlQuizSubjects', {
        fetch: 'FETCH_ITEMS',
      }),
      ...mapMutations('vlQuizSubjects', {
        resetWhere: 'RESET_WHERE',
      }),
    },
    mounted() {

      this.resetWhere();
      this.fetch();
    },
  };

</script>

<style lang="scss">

  .quiz-subjects-slider-block {
    color: inherit;
  }

</style>
